export enum SERVICE_MENU_ICON_NAME {
    PERSONAL_DATA = 'profile',
    GIFTS = 'gift',
    DEPOSIT = 'coinkeeper',
    WITHDRAWAL = 'withdraw',
    ACTIVE_STAKES = 'briefcase',
    BET_HISTORY = 'coupon',
    REFERRAL = 'past',
    NOTIFICATIONS = 'bell',
    CASHBACK = 'cashback',
    PREFERENCES = 'settings-gear',
}

export enum SERVICE_MENU_LIST_KEY {
    PERSONAL_DATA = 'personalData',
    GIFTS = 'gifts',
    DEPOSIT = 'deposit',
    WITHDRAWAL = 'withdrawal',
    ACTIVE_STAKES = 'active-stakes',
    BET_HISTORY = 'bet-history',
    REFERRAL = 'referral',
    NOTIFICATIONS = 'notifications',
    CASHBACK = 'cashback',
    PREFERENCES = 'preferences',
}
